export class DiscoverSecurityPrivs {
    public RssEnterpriseFeeds: {
        read: boolean;
        write: boolean;
    };

    public RssTeamFeeds: {
        read: boolean;
        write: boolean;
    };

    public RssPersonalFeeds: {
        read: boolean;
        write: boolean;
    };

    TwitterCredentialsManagement: boolean = false;

    public TwitterEnterpriseFeeds: {
        read: boolean;
        write: boolean;
    };

    public TwitterTeamFeeds: {
        read: boolean;
        write: boolean;
    };

    public TwitterPersonalFeeds: {
        read: boolean;
        write: boolean;
    };

    MediaCredentialsManagement: boolean = false;

    public MediaEnterpriseFeeds: {
        read: boolean;
        write: boolean;
    };

    public MediaTeamFeeds: {
        read: boolean;
        write: boolean;
    };

    public MediaPersonalFeeds: {
        read: boolean;
        write: boolean;
    };

    constructor() {
        this.RssEnterpriseFeeds = {
            read: false,
            write: false,
        };

        this.RssTeamFeeds = {
            read: false,
            write: false,
        };

        this.RssPersonalFeeds = {
            read: false,
            write: false,
        };

        this.TwitterEnterpriseFeeds = {
            read: false,
            write: false,
        };

        this.TwitterTeamFeeds = {
            read: false,
            write: false,
        };

        this.TwitterPersonalFeeds = {
            read: false,
            write: false,
        };

        this.MediaEnterpriseFeeds = {
            read: false,
            write: false,
        };

        this.MediaTeamFeeds = {
            read: false,
            write: false,
        };

        this.MediaPersonalFeeds = {
            read: false,
            write: false,
        };
    }

    public setPermissions(permissionsJson: string) {
        if (!permissionsJson) return;

        const permissions = JSON.parse(permissionsJson);

        this.RssEnterpriseFeeds.read = this.hasReadPermissions(permissions.StorytellingPermissions['rss-enterprise-feeds']);
        this.RssEnterpriseFeeds.write = this.hasWritePermissions(permissions.StorytellingPermissions['rss-enterprise-feeds']);
        this.RssTeamFeeds.read = this.hasReadPermissions(permissions.StorytellingPermissions['rss-team-feeds']);
        this.RssTeamFeeds.write = this.hasWritePermissions(permissions.StorytellingPermissions['rss-team-feeds']);
        this.RssPersonalFeeds.read = this.hasReadPermissions(permissions.StorytellingPermissions['rss-personal-feeds']);
        this.RssPersonalFeeds.write = this.hasWritePermissions(permissions.StorytellingPermissions['rss-personal-feeds']);

        this.TwitterCredentialsManagement = this.hasCredManagementPermissions(permissions.StorytellingPermissions['twitter-creds-mgt']);
        this.TwitterEnterpriseFeeds.read = this.hasReadPermissions(permissions.StorytellingPermissions['twitter-enterprise-feeds']);
        this.TwitterEnterpriseFeeds.write = this.hasWritePermissions(permissions.StorytellingPermissions['twitter-enterprise-feeds']);
        this.TwitterTeamFeeds.read = this.hasReadPermissions(permissions.StorytellingPermissions['twitter-team-feeds']);
        this.TwitterTeamFeeds.write = this.hasWritePermissions(permissions.StorytellingPermissions['twitter-team-feeds']);
        this.TwitterPersonalFeeds.read = this.hasReadPermissions(permissions.StorytellingPermissions['twitter-personal-feeds']);
        this.TwitterPersonalFeeds.write = this.hasWritePermissions(permissions.StorytellingPermissions['twitter-personal-feeds']);

        this.MediaCredentialsManagement = this.hasCredManagementPermissions(permissions.StorytellingPermissions['ap-creds-mgt']);
        this.MediaEnterpriseFeeds.read = this.hasReadPermissions(permissions.StorytellingPermissions['ap-enterprise-feeds']);
        this.MediaEnterpriseFeeds.write = this.hasWritePermissions(permissions.StorytellingPermissions['ap-enterprise-feeds']);
        this.MediaTeamFeeds.read = this.hasReadPermissions(permissions.StorytellingPermissions['ap-team-feeds']);
        this.MediaTeamFeeds.write = this.hasWritePermissions(permissions.StorytellingPermissions['ap-team-feeds']);
        this.MediaPersonalFeeds.read = this.hasReadPermissions(permissions.StorytellingPermissions['ap-personal-feeds']);
        this.MediaPersonalFeeds.write = this.hasWritePermissions(permissions.StorytellingPermissions['ap-personal-feeds']);
    }

    private hasReadPermissions(permission: string): boolean {
        return permission !== null && permission.includes('Read');
    }

    private hasWritePermissions(permission: string): boolean {
        return permission !== null && permission.includes('Read/Write');
    }

    private hasCredManagementPermissions(permission: string): boolean {
        return permission !== null && permission.toLowerCase() === 'true';
    }
}
